import React from 'react';
import ValidatedTextField from '../../components/forms/ValidatedTextField';
import Checkbox from 'material-ui/Checkbox';
import Button from 'material-ui/Button';
import {FormControlLabel} from 'material-ui/Form';

import tsl from '../tsl';
import axios from 'axios';
import { addAlert } from '../../actions/Alerts';
import {connect} from 'react-redux';

class PasswordResetForm extends React.Component {

    state = {
        password: '',
        password2: '',
        requestSent: false
    };

    onChange = (e) => {
        let newState = this.state;
        newState[e.target.name] = e.target.value;
        
        this.setState(newState);
    };

    submit = (e) => {
        e.preventDefault();

        this.setState({
            formSubmitted: true
        });

        if (!this.state.password || this.state.password.length == 0) {
            return;
        }

        if (!this.state.password2 || this.state.password2.length == 0 || this.state.password2 != this.state.password) {
            return;
        }

        axios.post(`/auth/password-reset/${this.props.match.params.token}`, {
            'password': this.state.password,
            'password2': this.state.password2
        })
        .then((res) => {
            this.props.addAlert(tsl('forgotpass.reset.success'), 'success');

            this.props.processLogin && this.props.processLogin(res).then(() => {
                this.props.history.push('/');
            });
        })
    };

    goBack = () => {
        this.props.history.push('/app/flights');
    };

    render() {
        const passwordsMatch = this.state.password === this.state.password2;
        const passwordInvalid = !this.state.password2 || !this.state.password || !passwordsMatch;

        return (
            <div
                className="login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
                <div className="login-content">
                    <div className="login-header mb-4">
                        <a className="app-logo" href="#/" title="Jambo">
                            <img src="./assets/images/logo-white-red.png" alt="jambo" title="jambo"/>
                        </a>
                    </div>

                    <div className="login-form">
                        <h2>{tsl("forgotpass.newpass.title")}</h2>
                        <form onSubmit={this.submit}>
                            <fieldset>
                                <ValidatedTextField
                                    type="password"
                                    required
                                    name="password"
                                    value={this.state.password}
                                    onChange={this.onChange}
                                    label={tsl("login.password")}
                                    fullWidth
                                    margin="normal"
                                    className="mt-1"
                                    disabled={this.state.requestSent}
                                />

                                <ValidatedTextField
                                    type="password"
                                    name="password2"
                                    value={this.state.password2}
                                    onChange={this.onChange}
                                    label={tsl("forgotpass.password2")}
                                    fullWidth
                                    margin="normal"
                                    className="mt-1"
                                    disabled={this.state.requestSent}
                                    error={!passwordsMatch}
                                    helperText={passwordsMatch ? undefined : tsl('forgotpass.passwords_do_not_match')}
                                />

                                <br /><br />

                                <Button type="submit" raised color="primary"
                                    className="jr-btn text-white btn-primary"
                                        disabled={this.state.requestSent || passwordInvalid}
                                >
                                    {tsl("forgotpass.btn")}
                                </Button>
                                
                                <Button onClick={this.goBack}>
                                    {tsl("forgotpass.back")}
                                </Button>


                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
};

export default connect(() => ({}), {addAlert})(PasswordResetForm);



// WEBPACK FOOTER //
// ./app/used/PasswordResetForm.js